import { EXPRESS_API } from 'configs/api/expressApi';
import { useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { backgroundsKeys } from './backgroundKeys';

export interface IBackgroundResponse {
  backgroundId: number;
  fileName: string;
  url: string;
  isGlobalDefault: boolean;
  customerId: number | null;
  default: boolean;
}

const getBackgrounds = async (): Promise<IBackgroundResponse[]> => {
  const response = await EXPRESS_API.get('/backgrounds');
  return response.data;
};

export const useQueryBackgrounds = () => {
  return useQuery(backgroundsKeys.all(), () => getBackgrounds(), {
    onError: () => {
      errorToast({
        title:
          "We're currently experiencing difficulties fetching backgrounds.",
      });
    },
  });
};
